var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.collaborationInvites),function(invite){return [(_vm.isUserOwner || invite.targetEmail === _vm.user.email)?_c('div',{key:invite.targetEmail,staticClass:"profile"},[_c('UserInvite',{attrs:{"invite":invite,"id":invite._id,"user":_vm.user,"isUserOwner":_vm.isUserOwner},on:{"refresh":_vm.handleRefresh}})],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }